import { getColorDepth } from './getColorDepth';

const { innerHeight, innerWidth } = window;
const { language, userAgent } = window.navigator;

export const buildScaData = () => ({
  timeZoneOffset: new Date().getTimezoneOffset(),
  browserScreenHeight: innerHeight,
  browserScreenWidth: innerWidth,
  browserJavascriptEnabled: true,
  browserColorDepth: getColorDepth(),
  browserLanguage: language,
  browserUserAgent: userAgent,
});
